import { createCustomAuthProvider } from "./auth/CustomAuthProvider";

// Custom authentication plugin - exported as a plugin, not authentication config
export const authenticationPlugin = createCustomAuthProvider({
	authApiUrl: process.env.ZUDOKU_PUBLIC_AUTH_API_URL || "http://localhost:9000",
	redirectToAfterSignIn: "/settings/api-keys",
	redirectToAfterSignOut: "/",
	enablePasswordAuth: true, // Enable email+password flow for custom login page
});
